/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'JOSEP CLARÀ',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(descarregar audios)',
        download:'Descàrrega dels arxius d\'audio',
        errorDownload: 'Hi hagut un error en la descàrrega.',
        cancelDownload: 'Has cancel·lat la descàrrega.',
        retry: 'Reintentar',
        noConnection: 'No tens conexió a internet',
        menuItems: [
            {
                idImages: 1,
                title: 'Josep Clarà',
                author: 'Preàmbul',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Autoretrat (1898)',
                author: 'Sala 0',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Jove florentí (1902)',
                author: 'Sala 0',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Èxtasi (1903)',
                author: 'Sala 1',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Meditació (1929-1930)',
                author: 'Sala 1',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Vida contemplativa (1917-1918)',
                author: 'Sala 1',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Del fang al guix',
                author: 'Sala 2',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Del guix al marbre',
                author: 'Sala 2',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Bronze',
                author: 'Sala 2',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Els tallers de París',
                author: 'Sala 2',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Dues ballarines',
                author: 'Sala 3',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Cap d\'Adela (1934-1935)',
                author: 'Sala 3',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Les germanes Deering (1923)',
                author: 'Sala 3',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'Monuments als caiguts',
                author: 'Sala 4',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'El Museu Clarà',
                author: 'Sala 4',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'La deessa (1928)',
                author: 'Sala 4',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Crèdits',
                isCredits:true,
                author: '',
                description: 'Guió i producció: Trama Media, 2021.<br><br>Textos citats:<br>La traducció del fragment de la <i>Ilíada</i> és de Lluís Segalà i Estalella.<br>El fragment de carta de Pau Gargallo a Josep Clarà s\'ha extret de l\'article “Els manuscrits i l’epistolari de Josep Clarà: proposta d’antologia”, de Bonaventura Bassegoda i Hugas.<br><br>Músiques:<br>Richard Wagner, <i>Idil·li de Sigfrid,</i> (Naxos) i Franz Schubert, <i>Marxa militar Op. 51, II</i> (Naxos).<br><br>Aquesta audioguia acompanya l’exposició ‘Josep Clarà i l’univers mediterrani’, organitzada per l’Ajuntament de Vila-seca i la Fundació Vila Casas amb la col·laboració del Museu de la Garrotxa, l’Ajuntament d’Olot, l’Ajuntament de Barcelona, la Filmoteca de Catalunya, el Museu Nacional d’Art de Catalunya i el Museu de la Terrissa de Quart.<br><br>© de les obres i de les imatges: els autors respectius.',
                audio: ''
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/catala.js